export default __webpack_public_path__ + "static/media/location_pin.69bc4dcf.png";